import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin";

const getAllAds = async (page = 1) => {
    const response = await axios.get(`${API_ENDPOINT}/ads?page=${page}`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });

    return response.data;
};
const addTextBanner = data => {
    return axios.post(`${API_ENDPOINT}/text-banner`, data, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const getTextBanner = async () => {
    const response = await axios.get(`${API_ENDPOINT}/text-banner`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
    return response.data;
};
const addAds = data => {
    return axios.post(`${API_ENDPOINT}/ads`, data, {
        withCredentials: true,
        headers: { ...authHeader() },
    });
};
const deleteAds = id => {
    return axios.delete(`${API_ENDPOINT}/ads/${id}`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const adsServices = {
    getAllAds,
    addAds,
    deleteAds,
    addTextBanner,
    getTextBanner,
};

export default adsServices;
